// extracted by mini-css-extract-plugin
export default {"museum-carousel-img":"Museum_museum-carousel-img__gir9v"};